import {
  BadgeCheck,
  ClipboardCheck,
  ClipboardList,
  LayoutDashboard,
  ListChecks,
  Rocket,
  Star,
  UserCog,
} from 'lucide-react';

import { getRoutingPath, ROUTES } from '../../../../constants/routingPath';
import { MenuItem } from './asideNavigation';

const ENTERPRISE_FEATURES = false;

export const talentMenuItems = ({
  isBoosted,
  onBoostClick,
  showBoostMenuItem,
  talentInvitationCount,
}: {
  isBoosted?: boolean;
  onBoostClick?: () => void;
  showBoostMenuItem?: boolean;
  talentInvitationCount: number;
}): MenuItem[] => [
  {
    icon: LayoutDashboard,
    iconSelected: LayoutDashboard,
    label: 'Dashboard',
    link: getRoutingPath(ROUTES.TALENT_DASHBOARD),
  },
  {
    badge: talentInvitationCount,
    icon: ListChecks,
    iconSelected: ListChecks,
    label: 'Invitations',
    link: getRoutingPath(ROUTES.TALENT_INVITATIONS),
  },
  {
    icon: ClipboardCheck,
    iconSelected: ClipboardCheck,
    label: 'Applied Jobs',
    link: getRoutingPath(ROUTES.TALENT_APPLIED_JOBS),
  },
  {
    icon: isBoosted ? Star : UserCog,
    iconSelected: isBoosted ? Star : UserCog,
    label: 'Profile',
    link: getRoutingPath(ROUTES.TALENT_PROFILE),
  },
  ...(showBoostMenuItem
    ? ([
        {
          icon: Rocket,
          iconSelected: Rocket,
          label: 'Boost profile',
          onClick: onBoostClick,
        },
      ] as MenuItem[])
    : []),
  ...(ENTERPRISE_FEATURES
    ? ([
        {
          icon: ClipboardList,
          iconSelected: ClipboardList,
          label: 'Assignments',
          link: getRoutingPath(ROUTES.TALENT_ASSIGNMENTS),
        },
        {
          icon: BadgeCheck,
          iconSelected: BadgeCheck,
          label: 'My Provider Companies',
          link: getRoutingPath(ROUTES.TALENT_PROVIDERS),
        },
      ] as MenuItem[])
    : []),
];
